export default () => {
  const icon = document.querySelector('.icon-menu');
  const menuButton = document.querySelector('.menu__button');

  const openMenu = () => {
    document.documentElement.classList.add('menu-open');
    icon.classList.add('active');
    menuButton.classList.add('active');
  };

  const closeMenu = () => {
    document.documentElement.classList.remove('menu-open');
    icon.classList.remove('active');
    menuButton.classList.remove('active');
  };

  icon.addEventListener('click', function () {
    const isMenuOpen = document.documentElement.classList.toggle('menu-open');

    if (isMenuOpen) {
      this.classList.add('active');
      menuButton.classList.add('active');
    } else {
      this.classList.remove('active');
      menuButton.classList.remove('active');
    }
  });

  const menuLinks = document.querySelectorAll('.menu__link');
  menuLinks.forEach((menuLink) => {
    menuLink.addEventListener('click', closeMenu);
  });
};








